import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import styled from 'styled-components';
import {useAccordionContext} from 'shared/components/Accordion';

interface ItemProps {
    children?: React.ReactNode;
    eventKey: string | number;
}

interface ItemContext {
    isActive?: boolean;
}

const ItemContext = createContext<ItemContext>({});

export const useItemContext = () => useContext(ItemContext);

export const Item = ({children, eventKey}: ItemProps) => {
    const [isActive, setIsActive] = useState(false);
    const {activeKey, setActiveKey} = useAccordionContext();

    const clickHandler = useCallback(() => {
        setActiveKey(eventKey);
    }, [eventKey, setActiveKey]);

    useEffect(() => {
        setIsActive(activeKey === eventKey);
    }, [activeKey]);

    return (
        <ItemContext.Provider value={{isActive}}>
            <ItemContainer onClick={clickHandler}>{children}</ItemContainer>
        </ItemContext.Provider>
    );
};

const ItemContainer = styled.div`
    border: 1px solid #d5d5d5;
    border-bottom: 0;

    &:first-child {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;

        > div {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
        }
    }

    &:last-child {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-bottom: 1px solid #d5d5d5;

        > div:last-child {
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
        }
    }
`;
